import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=3711b36d&scoped=true&"
import script from "./ContactView.vue?vue&type=script&lang=js&"
export * from "./ContactView.vue?vue&type=script&lang=js&"
import style0 from "./ContactView.vue?vue&type=style&index=0&id=3711b36d&prod&lang=scss&scoped=true&"
import style1 from "./ContactView.vue?vue&type=style&index=1&id=3711b36d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3711b36d",
  null
  
)

export default component.exports